import { render, staticRenderFns } from "./CustomReportAmar.vue?vue&type=template&id=8dc63742&scoped=true&"
import script from "./CustomReportAmar.vue?vue&type=script&lang=js&"
export * from "./CustomReportAmar.vue?vue&type=script&lang=js&"
import style0 from "./CustomReportAmar.vue?vue&type=style&index=0&id=8dc63742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc63742",
  null
  
)

export default component.exports